class Store {}

export const ChartsTabStore = new Store();
